"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _Render2 = _interopRequireDefault(require("../../Row/Render"));

var _Render3 = _interopRequireDefault(require("./Render"));

var _Form = _interopRequireDefault(require("./Form"));

var _Row = _interopRequireDefault(require("../../Row"));

var _assign = _interopRequireDefault(require("lodash/assign"));

var _default = (0, _assign["default"])({}, _Row["default"], {
  Form: _Form["default"],
  Render: function Render(props) {
    var isEditor = props.internals.isEditor;
    return /*#__PURE__*/(0, _react.createElement)(isEditor ? _Render2["default"] : _Render3["default"], props);
  }
});

exports["default"] = _default;